import React from "react";
import DisplayField from "../DisplayField";
import Contact from "./Contact";
import { FormGroup, ControlLabel, FormControl } from "react-bootstrap";
import styles from "./JobEvent.css";

const Details = ({ event }) => (
  <div>
    <DisplayField group="details" field="customerName">
      <FormGroup className={styles.dataValuePair}>
        <ControlLabel className={styles.dataValuePairLabel}>
          Customer
        </ControlLabel>
        <FormControl.Static
          className={styles.dataValuePairValue}
          componentClass={"div"}
        >
          {event.job.customer ? event.job.customer.name : "N/A"}
        </FormControl.Static>
      </FormGroup>
    </DisplayField>
    {event.job.salesperson && (
      <DisplayField group="details" field="salesperson">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Salesperson
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.job.salesperson.firstName} {event.job.salesperson.lastName}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}
    {event.job.status && (
      <DisplayField group="details" field="jobStatus">
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Job Status
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.job.status}
          </FormControl.Static>
        </FormGroup>
      </DisplayField>
    )}
    <DisplayField group="details" field="contact">
      {event.job.contacts.length > 0 && (
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Contacts
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            <p>
              <Contact contact={event.job.contacts[0]} />
            </p>
          </FormControl.Static>
        </FormGroup>
      )}
    </DisplayField>
    <DisplayField group="details" field="priorityNotes">
      {event.job.priorityNotes && (
        <FormGroup className={styles.dataValuePair}>
          <ControlLabel className={styles.dataValuePairLabel}>
            Priority Notes
          </ControlLabel>
          <FormControl.Static
            className={styles.dataValuePairValue}
            componentClass={"div"}
          >
            {event.job.priorityNotes}
          </FormControl.Static>
        </FormGroup>
      )}
    </DisplayField>
  </div>
);

export default Details;
